import { render, staticRenderFns } from "./MoneyField.vue?vue&type=template&id=55da15cb&scoped=true"
import script from "./MoneyField.vue?vue&type=script&lang=ts"
export * from "./MoneyField.vue?vue&type=script&lang=ts"
import style0 from "./MoneyField.vue?vue&type=style&index=0&id=55da15cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da15cb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
